import { render, staticRenderFns } from "./Redirection.vue?vue&type=template&id=88f3c63a"
import script from "./Redirection.vue?vue&type=script&setup=true&lang=js"
export * from "./Redirection.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Redirection.vue?vue&type=style&index=0&id=88f3c63a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports